import { startCase } from 'lodash';
import { chartEmptyValueConstants } from '../chartEmptyValueConstants';
import { formatMonthString } from '../chartTableFlatTransformer';

// note: for contacts we are only getting contacts_created in headers so as of now we can't change it to any other custom custom in next version

export const contactsTrendTransformer = ({ response }) => {
  const {
    table = [], // Optional, defaults to an empty array if not provided
    headers = [], // Default to an empty array to avoid issues with missing headers
    lookups: { dt = [], g2 = [] } = {}, // Handle optional lookups and defaults
  } = response || {};

  // Prepare the x-axis data (categories) from the 'dt' lookup with formatted months
  const categories = dt.map(formatMonthString);

  // Find the index of 'contacts_created' in the headers for easy access to relevant data
  const valueIndex = headers.indexOf('contacts_created');

  // If 'contacts_created' is not found in headers, return empty series
  if (valueIndex === -1) {
    return {
      categories, // Return x-axis data (even if empty)
      series: [], // No y-axis data as 'contacts_created' is missing
    };
  }

  const series = g2.map((source, index) => ({
    data: Array(categories.length).fill(0),
    name:
      source?.name ||
      (source ? startCase(source) : chartEmptyValueConstants?.appl_source),
    g2: source?.id || null,
  }));

  // Prepare the series data for each entry in the 'g2' lookup (which now assumes g2 is an array of strings)
  table.forEach((weekRow) => {
    const weekIndex = weekRow[1]; // Week index (0, 1, 2, etc.)
    const sources = weekRow[0]; // Nested array of source data

    // Process each source entry for this week
    sources.forEach((sourceData) => {
      const g2Index = sourceData[3]; // g2 index (0, 1, 2, 3)
      const value = sourceData[valueIndex]; // contacts_created value

      // If g2Index is valid and within our array bounds
      if (g2Index !== null && g2Index >= 0 && g2Index < series.length) {
        series[g2Index].data[weekIndex] = value;
      }
    });
  });

  // Return the transformed chart data with categories (x-axis) and series (y-axis)
  return {
    categories, // X-axis data (e.g., dates, times)
    series, // Y-axis data for different groups (e.g., contacts created per group)
  };
};
